import { getHoursAndMinutes } from "@enos-monorepo/lib";

interface ShiftHoursProps {
  start?: string;
  end?: string;
  onClick?: () => void;
  isOpen?: boolean;
  opacity?: number;
}

export function ShiftHours({
  start,
  end,
  onClick,
  isOpen,
  opacity,
}: ShiftHoursProps) {
  return (
    <div
      className={`border-[1px] font-normal rounded-[5px] mx-auto text-2sm py-2.5 w-fit px-1.5 block
      ${onClick ? "cursor-pointer" : ""}
      ${isOpen ? "border-[#DFA000] bg-white text-[#DFA000]" : "border-[#296573] bg-white text-[#296573]"}
      opacity-${opacity}
      `}
      onClick={onClick}
    >
      <div className="flex flex-row flex-wrap items-center justify-center">
        <span className="whitespace-nowrap">{getHoursAndMinutes(start)}</span>{" "}
        <span> - </span>{" "}
        <span className="whitespace-nowrap">{getHoursAndMinutes(end)}</span>
      </div>
    </div>
  );
}
